import { Button } from "primereact/button";
import { useCallback } from "react";
import { useToast } from "@/core/hooks/useToast";
import "./Share.scss";

export const Share = () => {
  const { showSuccess, showError } = useToast();

  const handleCopyUrl = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      showSuccess("URL copied to clipboard");
    } catch (error) {
      showError("Failed to copy URL");
    }
  }, [showSuccess, showError]);

  return (
    <button className="share-btn social-btn" onClick={handleCopyUrl}>
      <i className="pi pi-share-alt" />
    </button>
  );
};
